import { suggestedProducts } from 'services/searchSuggestions/types';

export function mapSuggestedProducts(
  suggestedProducts: suggestedProducts[],
  esiteUrl: string,
  featureFlag: boolean
): suggestedProducts[] {
  return suggestedProducts.map((product) => ({
    ...product,
    value: featureFlag
      ? `${esiteUrl}/product/${product.partNumber}`
      : product.value
  }));
}
